<template>
    <div class="container pt-4">
        <PlansDetailsCollapse
            @loadCourseContent="loadCourseContent"
            :planId="model.id"
            :courseId="courseId"
        ></PlansDetailsCollapse>
    </div>
</template>

<script>
import Spinner from "../Common/LoadingSpinner";
import PlansDetailsCollapse from "./PlanDetailsCollapse";

import Card from "../../argon/components/Cards/Card";
import Collapse from "../../argon/components/Collapse/Collapse";
import CollapseItem from "../../argon/components/Collapse/CollapseItem";
import BasePagination from "../../argon/components/BasePagination";

export default {
    name: "PlanDetailContent",
    components: {
        Card,
        Collapse,
        CollapseItem,
        Spinner,
        BasePagination,
        PlansDetailsCollapse
    },
    props: {
        model: Object
    },

    data() {
        return {
            courseId: null
        };
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        }
    },
    methods: {
        loadCourseContent(event) {
            this.courseId = event;
        }
    }
};
</script>

<style scoped>
</style>
